import { Dispatch, SetStateAction } from "react";

export enum CurbZonePageModeType {
  View = "view",
  Add = "addCurbZone",
  Edit = "editCurbZone",
  MultiEdit = "multiEditCurbZone",
  AddCurbArea = "addCurbArea",
  EditCurbArea = "editCurbArea",
  AddParkingLot = "addParkingLot",
  EditParkingLot = "editParkingLot",
  AddWorkArea = "addWorkArea",
  EditWorkArea = "editWorkArea",
}

export type CurbZonePageAttribute<T> = {
  [key in CurbZonePageModeType]: T;
};

/**
 * Allowed/registered App Modes
 */
export type CurbZoneMapMode<T = unknown> = keyof CurbZonePageAttribute<T>;

export type CurbZoneMapProps<T = unknown> = {
  appMode: keyof CurbZonePageAttribute<T>;
  setAppMode: Dispatch<SetStateAction<CurbZoneMapMode>>;
};

export type CurbZoneParams = {
  startDate?: string;
  endDate?: string;
  view?: string;
  cityID?: string;
  policies?: string;
};
